import Swiper from "swiper"
import { find } from "../utils/dom"

export default function () {
	const Home = find("[js-page='home']")
	if (!Home) return

	console.log('Page home');
	var swiperTeam = new Swiper(".swiper-team-top-new", {
			slidesPerView:'auto',
			spaceBetween:8,
      navigation: {
        nextEl: ".swiper-team-button-next",
        prevEl: ".swiper-team-button-prev",
      },
    });

		var swiperTeamBottom = new Swiper(".swiper-team-bottom-new", {
			slidesPerView:'auto',
			spaceBetween:8,
			slidesOffsetBefore:24,
			pagination:{
				el: ".swiper-pagination",
        clickable: true,
				renderBullet: function (index, className) {
					if (index < 8) {
						return `<span class="${className}"></span>`;
					}
					return '';
				}
			},
      navigation: {
        nextEl: ".swiper-team-button-next",
        prevEl: ".swiper-team-button-prev",
      },
    });

	const clickFilterTeam = (swiper) => {
		const cardsTeamTop = document.querySelectorAll('.card-team-top')
		const allSlides = Array.from(swiper.slides)
  	const emptyMessage = document.getElementById('empty-message')

		cardsTeamTop.forEach(card => {
			card.addEventListener('click', () => {

				cardsTeamTop.forEach(c => c.classList.remove('active'))
				card.classList.add('active')

				const categoria = card.dataset.categoriaCargo
				swiper.removeAllSlides()

				const slidesToShow = categoria === 'todos'
					? allSlides
					: allSlides.filter(slide => slide.dataset.categoriaCargoPeople === categoria)

				if(slidesToShow.length === 0){
					emptyMessage.classList.toggle('hidden')
				} else {
					emptyMessage.classList.add('hidden')
					swiper.appendSlide(slidesToShow)
				}
				swiper.update()
			})
		})
	}



		clickFilterTeam(swiperTeamBottom)
}